module.exports = __webpack_public_path__ + "static/media/preview1-small.98270db0.jpg";